import React, { useEffect, useMemo, useState } from "react";

const ExcelTable = ({
  rows,
  trips = [],
  monthLabel = "",
  mode = "reservations",     
  onModeChange,                
  onFilterChange,
  year,
  month,
}) => {
  const [trip, setTrip] = useState("all");
  const d = (x) => (x ? new Date(x).toLocaleDateString("pl-PL") : "—");
  const join = (arr) => (arr && arr.length ? arr.join(", ") : "—");

  const asButtonDivProps = (onClick) => ({
    role: "button",
    tabIndex: 0,
    onClick,
    onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    },
  });

  const computeBucket = (r) => {
    if (!year || !month) return 0;
    const start = new Date(year, month - 1, 1);
    const end = new Date(year, month, 1);
    const confirmedInM = r?.confirmedAt && new Date(r.confirmedAt) >= start && new Date(r.confirmedAt) < end;
    const cancelledInM = !!r?.cancelledAtEom;
    if (confirmedInM && !cancelledInM) return 1; 
    if (!confirmedInM && cancelledInM) return 2; 
    if (confirmedInM && cancelledInM) return 3;  
    return 0;
  };

const filtered = useMemo(() => {
  let data = rows ?? [];
  if (trip !== "all") {
    data = data.filter((r) => String(r.tripGuid) === String(trip));
  }

  if (mode === "reservations") {
    data = data.filter((r) => r.hasReservationActionInM === true);
  } else {
    data = data.filter((r) =>
      (r.confirmed_People ?? 0) +
      (r.confirmedBefore_CancelledInM_People ?? 0) +
      (r.confirmedInM_CancelledInM_People ?? 0) > 0
    );
  }

  return data;
}, [rows, trip, mode]);


  useEffect(() => {
    if (typeof onFilterChange === "function") onFilterChange(filtered);
  }, [filtered, onFilterChange, mode]);

const Row = ({ r, children }) => {
  let rowClass = "";
  if (mode === "people" && r.hasReservationActionInM === false) {
    rowClass = "row-gray";
  } else {
    const b = computeBucket(r);
    rowClass = b === 2 ? "row-red" : b === 3 ? "row-yellow" : "";
  }

  return <tr className={rowClass}>{children}</tr>;
};

  return (
    <section className="ufg-section">
      <div className="ufg-section-header">
        <div className="ufg-togglebar" role="tablist" aria-label="Przełącz widok">
          <div
            className={`ufg-toggle ${mode === "reservations" ? "is-active" : ""}`}
            {...asButtonDivProps(() => onModeChange?.("reservations"))}
            role="tab"
            aria-selected={mode === "reservations"}
          >
            Akcje na rezerwacjach
          </div>
          <div
            className={`ufg-toggle ${mode === "people" ? "is-active" : ""}`}
            {...asButtonDivProps(() => onModeChange?.("people"))}
            role="tab"
            aria-selected={mode === "people"}
          >
            Akcje na osobach
          </div>
        </div>

        <div className="ufg-filters">
          <label className="ufg-filter">
            Wycieczka:&nbsp;
            <select value={trip} onChange={(e) => setTrip(e.target.value)}>
              <option value="all">Wszystkie</option>
              {trips.map((t) => (
                <option key={t.tripGuid} value={t.tripGuid}>
                  {t.tripName}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>
            <div className="ufg-notice">
        Poniższy widok prezentuje wyłącznie działania wykonane w <b>{monthLabel}</b> —
        potwierdzanie i anulowanie rezerwacji oraz osób uczestniczących.
        To migawka aktywności w danym miesiącu. <b>Aktualny stan rezerwacji</b> (po wszystkich późniejszych zmianach) uzyskasz w eksporcie do Excela.
      </div>

      <div className="table-wrap">
        {mode === "reservations" ? (
          <table className="ufg-table ufg-table--wide">
            <thead>
              <tr>
                <th>Wycieczka</th>
                <th>Wariant</th>
                <th>Numer rezerwacji</th>
                <th>Data potwierdzenia</th>
                <th>Data anulowania</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r, i) => (
                <Row r={r} key={i}>
                  <td>{r.tripName}</td>
                  <td>{r.variantName}</td>
                  <td>{r.registrationCode}</td>
                  <td>{d(r.confirmedAt)}</td>
                  <td>{d(r.cancelledAtEom)}</td>
                </Row>
              ))}
              {!filtered.length && (
                <tr>
                  <td colSpan={5} className="empty">
                    Brak danych
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <table className="ufg-table ufg-table--wide">
            <thead>
              <tr>
                <th>Wycieczka</th>
                <th>Wariant</th>
                <th>Numer rezerwacji</th>
                <th>Os. potwierdzone</th>
                <th>Os. potw. przed i anul. w {monthLabel}</th>
                <th>Os. potw. i anul. w {monthLabel}</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r, i) => (
                <Row r={r} key={i}>
                  <td>{r.tripName}</td>
                  <td>{r.variantName}</td>
                  <td>{r.registrationCode}</td>
                  <td>{r.confirmed_People ?? 0}</td>
                  <td>{r.confirmedBefore_CancelledInM_People ?? 0}</td>
                  <td>{r.confirmedInM_CancelledInM_People ?? 0}</td>
                </Row>
              ))}
              {!filtered.length && (
                <tr>
                  <td colSpan={9} className="empty">
                    Brak danych
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
};

export default ExcelTable;
